import React, { FC, useEffect } from "react"
import { useBlocker } from "react-router-dom"

import DataLossWarningModal, { IDataLossWarningModalProps } from "./DataLossWarningModal"

interface IDataLossWarningProps extends Omit<IDataLossWarningModalProps, "onConfirm" | "onClose"> {
    enabled?: boolean
    onConfirm?(): void
}

const DataLossWarning: FC<React.PropsWithChildren<IDataLossWarningProps>> = ({
    enabled = false,
    onConfirm,
    ...props
}) => {
    const blocker = useBlocker(enabled)

    // in-app navigation is handled by the blocker; hard navigations
    // (tab close, reload, external links) get the native browser prompt
    useEffect(() => {
        if (!enabled) return
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            e.preventDefault()
            e.returnValue = ""
        }
        window.addEventListener("beforeunload", handleBeforeUnload)
        return () => window.removeEventListener("beforeunload", handleBeforeUnload)
    }, [enabled])

    useEffect(() => {
        if (blocker.state === "blocked" && !enabled) {
            blocker.reset()
        }
    }, [blocker, enabled])

    if (blocker.state !== "blocked") {
        return null
    }

    return (
        <DataLossWarningModal
            onClose={() => blocker.reset()}
            onConfirm={() => {
                blocker.proceed()
                if (typeof onConfirm === "function") {
                    onConfirm()
                }
            }}
            {...props}
        />
    )
}

export default DataLossWarning
